module.exports = __webpack_public_path__ + "static/img/smt_material_develop.aab010a1.png";